import React from "react";

import { useSidebar } from "./hooks/useSidebar";

interface SidebarMenuProps {
  className?: string;
  children: React.ReactNode;
}

/**
 * SidebarMenu - Container for menu items
 *
 * @param className - Additional CSS classes
 * @param children - Menu items (SidebarMenuItem components)
 */
export function SidebarMenu({ className = "", children }: SidebarMenuProps) {
  const { state } = useSidebar();

  return (
    <ul
      className={`
        flex flex-col gap-2xs list-none m-0 p-0
        ${className}
      `.trim()}
      role="menu"
      data-state={state}
    >
      {children}
    </ul>
  );
}
